export enum AuditPostTypes {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  FILE_ADD = 'file_add',
  FILE_REMOVE = 'file_remove',
  POST = 'POST',
  SCHEDULED_POST = 'SCHEDULED_POST',
}
